var _circle, _path, _path2, _circle2, _path3, _path4, _path5, _path6, _circle3, _path7, _path8, _path9, _path10, _circle4, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _circle5, _path25, _path26, _circle6, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoTasks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "undraw_to_do_re_jaef",
    xmlns: "http://www.w3.org/2000/svg",
    width: 238.229,
    height: 151.654,
    viewBox: "0 0 238.229 151.654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_12",
    "data-name": "Elipse 12",
    cx: 7.837,
    cy: 7.837,
    r: 7.837,
    transform: "translate(67.265 88.789)",
    fill: "#236fe2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_37",
    "data-name": "Caminho 37",
    d: "M339.04,321.436l-2.345-3.016,1.364-1.061,1.111,1.428,3.752-3.961,1.255,1.189Z",
    transform: "translate(-264.82 -221.503)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_38",
    "data-name": "Caminho 38",
    d: "M709.515,219.1h-116.5V194.2h116.5Z",
    transform: "translate(-494.782 -194.199)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_13",
    "data-name": "Elipse 13",
    cx: 6.325,
    cy: 6.325,
    r: 6.325,
    transform: "translate(114.167 6.125)",
    fill: "#236fe2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_39",
    "data-name": "Caminho 39",
    d: "M690.722,221.973a1.054,1.054,0,0,0,0,2.108h76.971a1.054,1.054,0,0,0,0-2.108Z",
    transform: "translate(-562.782 -213.74)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_40",
    "data-name": "Caminho 40",
    d: "M690.716,243.312a1.054,1.054,0,0,0,0,2.108h48.662a1.054,1.054,0,1,0,0-2.108Z",
    transform: "translate(-558.428 -228.753)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_41",
    "data-name": "Caminho 41",
    d: "M709.515,219.1h-116.5V194.2h116.5ZM594.8,217.321h112.94V195.978H594.8Z",
    transform: "translate(-494.782 -194.199)",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_42",
    "data-name": "Caminho 42",
    d: "M709.515,324.1h-116.5V299.2h116.5Z",
    transform: "translate(-494.782 -268.074)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_14",
    "data-name": "Elipse 14",
    cx: 6.325,
    cy: 6.325,
    r: 6.325,
    transform: "translate(114.167 37.25)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43",
    "data-name": "Caminho 43",
    d: "M690.722,326.973a1.054,1.054,0,0,0,0,2.108h76.971a1.054,1.054,0,0,0,0-2.108Z",
    transform: "translate(-562.782 -287.615)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_44",
    "data-name": "Caminho 44",
    d: "M690.716,348.312a1.054,1.054,0,0,0,0,2.108h48.662a1.054,1.054,0,1,0,0-2.108Z",
    transform: "translate(-558.428 -302.628)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_45",
    "data-name": "Caminho 45",
    d: "M709.515,324.1h-116.5V299.2h116.5ZM594.8,322.321h112.94V300.978H594.8Z",
    transform: "translate(-494.782 -268.074)",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_46",
    "data-name": "Caminho 46",
    d: "M709.515,429.1h-116.5V404.2h116.5Z",
    transform: "translate(-494.782 -341.949)",
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_15",
    "data-name": "Elipse 15",
    cx: 6.325,
    cy: 6.325,
    r: 6.325,
    transform: "translate(114.167 68.375)",
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_47",
    "data-name": "Caminho 47",
    d: "M690.722,431.973a1.054,1.054,0,0,0,0,2.108h76.971a1.054,1.054,0,0,0,0-2.108Z",
    transform: "translate(-562.782 -361.49)",
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48",
    "data-name": "Caminho 48",
    d: "M690.716,453.312a1.054,1.054,0,0,0,0,2.108h48.662a1.054,1.054,0,1,0,0-2.108Z",
    transform: "translate(-558.428 -376.503)",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_49",
    "data-name": "Caminho 49",
    d: "M709.515,429.1h-116.5V404.2h116.5ZM594.8,427.321h112.94V405.978H594.8Z",
    transform: "translate(-494.782 -341.949)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_50",
    "data-name": "Caminho 50",
    d: "M333,478.368a2.958,2.958,0,0,1,.956-4.434l-.618-6.732,4-1.373.739,9.519a2.974,2.974,0,0,1-5.076,3.02Z",
    transform: "translate(-296.9 -385.31)",
    fill: "#ffb8b8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_51",
    "data-name": "Caminho 51",
    d: "M337.128,367.9s2.744-5.76,5.183-3.734-3.343,19.056-3.343,19.056l-.879,16.532-4.635-.463-1.31-16.107Z",
    transform: "translate(-296.739 -313.482)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_52",
    "data-name": "Caminho 52",
    d: "M91.056,439.55l3.44,2.785,12.379-11.945-5.078-4.11Z",
    transform: "translate(-87.479 -299.918)",
    fill: "#ffb8b8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_53",
    "data-name": "Caminho 53",
    d: "M216.315,659.06l6.776,5.485h0a5.556,5.556,0,0,1,.822,7.813l-.114.14-11.093-8.98Z",
    transform: "translate(-212.707 -521.261)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_54",
    "data-name": "Caminho 54",
    d: "M252.355,456.6h4.426l2.106-17.073h-6.533Z",
    transform: "translate(-203.99 -309.24)",
    fill: "#ffb8b8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_55",
    "data-name": "Caminho 55",
    d: "M382.266,686.45h8.718A5.556,5.556,0,0,1,396.539,692v.181H382.266Z",
    transform: "translate(-335.06 -540.532)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_56",
    "data-name": "Caminho 56",
    d: "M291.448,421.309s8.3,10.109,6.5,20.219-3.249,17.691-3.249,17.691l-2.888,22.746s1.083,6.195-.361,7.791c0,0,2.166,3.763-1.805,5.207s-6.114-.5-6.114-.5-2.912-4.195-1.107-5.278l.76-44.639L254.26,482.326s-.532,4.6-4.237,4.645l-4.428,3.3-5.055-2.888,2.527-3.249s-1.444-3.61,1.805-4.333l18.775-24.551,4.694-12.637s2.527-9.748,9.387-13.72v-4.226Z",
    transform: "translate(-232.29 -353.987)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_57",
    "data-name": "Caminho 57",
    d: "M353.995,356.442h0a6.894,6.894,0,0,1,9.087-1.283l.3.2h0a26.613,26.613,0,0,1,6.23,12.827l1.352,7.392-16.969,3.676-3.978-13.72a7.751,7.751,0,0,1,3.978-9.092Z",
    transform: "translate(-311.641 -306.63)",
    fill: "#ccc"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_58",
    "data-name": "Caminho 58",
    d: "M442.015,478.605a3.386,3.386,0,0,1-1.931-4.819l-4.9-5.991,2.915-3.863,6.794,8.558a3.4,3.4,0,0,1-2.883,6.115Z",
    transform: "translate(-373.2 -383.976)",
    fill: "#ffb8b8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_59",
    "data-name": "Caminho 59",
    d: "M388.164,364.193s-1.083-7.221,2.527-6.86,9.026,20.219,9.026,20.219l9.748,16.247-4.694,2.527-11.554-14.442Z",
    transform: "translate(-339.304 -308.966)",
    fill: "#ccc"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_60",
    "data-name": "Caminho 60",
    d: "M366.858,300.568H349.665a1.335,1.335,0,0,1-1.334-1.334v-7.411a9.93,9.93,0,0,1,19.861,0v7.411A1.335,1.335,0,0,1,366.858,300.568Z",
    transform: "translate(-310.631 -255.898)",
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_16",
    "data-name": "Elipse 16",
    cx: 7.281,
    cy: 7.281,
    r: 7.281,
    transform: "translate(42.16 29.936)",
    fill: "#ffb8b8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_61",
    "data-name": "Caminho 61",
    d: "M387.691,298.9h-9.163l-.094-1.509-.47,1.509h-1.411l-.186-2.992-.931,2.992h-2.73v-.148c0-4.332,3.071-7.855,6.846-7.855h1.292c3.775,0,6.846,3.524,6.846,7.855Z",
    transform: "translate(-328.17 -262.23)",
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_62",
    "data-name": "Caminho 62",
    d: "M366.947,308.166a2.2,2.2,0,0,1-.334-.026l-10.906-1.68V295.1a4.375,4.375,0,0,1,4.375-4.375h7.63l-.3.3c-4.135,4.21-1.02,11.037,1.205,14.732a1.456,1.456,0,0,1-.148,1.726A1.981,1.981,0,0,1,366.947,308.166Z",
    transform: "translate(-315.883 -262.113)",
    fill: "#2f2e41"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_17",
    "data-name": "Elipse 17",
    cx: 7.837,
    cy: 7.837,
    r: 7.837,
    transform: "translate(222.556 4.603)",
    fill: "#236fe2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_63",
    "data-name": "Caminho 63",
    d: "M897.04,37.436,894.7,34.421l1.364-1.061,1.111,1.428,3.752-3.961,1.255,1.189Z",
    transform: "translate(-667.395 -21.689)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTasks);
export default __webpack_public_path__ + "static/media/no-tasks.cba6889ae9fd03df97ac36594b86a3fc.svg";
export { ForwardRef as ReactComponent };